import { StackNavigationProp } from "@react-navigation/stack"
import { RootStackParamList } from "../../router/types.ts"
import { FullScreenErrorV2 } from "../../components"
import { RouteProp } from "@react-navigation/native"

type GeneralErrorScreenNavigationProp = StackNavigationProp<RootStackParamList, "GeneralError">
type GeneralErrorScreenRouterProp = RouteProp<RootStackParamList, "GeneralError">

type GeneralErrorScreenProp = {
  navigation: GeneralErrorScreenNavigationProp
  route: GeneralErrorScreenRouterProp
}

export function GeneralErrorScreen({ navigation, route }: GeneralErrorScreenProp) {
  const { message, label, onButtonPress, buttonLabel = "Try again" } = route.params

  return (
    <FullScreenErrorV2
      label={label || "One quick thing"}
      message={message}
      buttonLabel={buttonLabel}
      onPress={() => {
        if (onButtonPress) {
          onButtonPress()
          return
        }

        navigation.goBack()
      }}
    />
  )
}
